<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">显示屏名称：</span>
        </div>
        <el-input v-model="displayName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">显示屏类型：</span>
        </div>
        <el-select v-model="displayType" size="small" style="width: 280px">
          <el-option v-for="item in displayTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应用场景：</span>
        </div>
        <el-select v-model="applicationScenario" size="small" style="width: 280px">
          <el-option v-for="item in applicationScenarioList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联相机：</span>
        </div>
        <el-select v-model="deviceCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">静态内容：</span>
        </div>
        <div>
          <div v-for="staticData in staticInfo" style="margin-bottom: 10px;">
            <el-select v-model="staticData.code" size="small" style="width: 280px;margin-right: 20px;">
              <el-option v-for="item in staticList" :key="item.code"
                         :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="staticData.name" size="small" style="width: 280px" v-if="staticData.code.indexOf('G000000') === -1" />
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">包月内容：</span>
        </div>
        <div>
          <div v-for="staticData in monthlyInfo" style="margin-bottom: 10px;">
            <el-select v-model="staticData.code" size="small" style="width: 280px;margin-right: 20px;">
              <el-option v-for="item in monthlyList" :key="item.code"
                         :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="staticData.name" size="small" style="width: 280px" v-if="staticData.code.indexOf('G000000') === -1" />
          </div>
        </div>
      </div>

      <div class="form-line" v-if="applicationScenario === '入场'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">临停车(入场)：</span>
        </div>
        <div>
          <div v-for="staticData in enterInfo" style="margin-bottom: 10px;">
            <el-select v-model="staticData.code" size="small" style="width: 280px;margin-right: 20px;">
              <el-option v-for="item in enterList" :key="item.code"
                         :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="staticData.name" size="small" style="width: 280px" v-if="staticData.code.indexOf('G000000') === -1" />
          </div>
        </div>
      </div>

      <div class="form-line" v-if="applicationScenario === '出场'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">临停车(出场)：</span>
        </div>
        <div>
          <div v-for="staticData in vehicleInfo" style="margin-bottom: 10px;">
            <el-select v-model="staticData.code" size="small" style="width: 280px;margin-right: 20px;">
              <el-option v-for="item in vehicleList" :key="item.code"
                         :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="staticData.name" size="small" style="width: 280px" v-if="staticData.code.indexOf('G000000') === -1" />
          </div>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ParkingService'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'display-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'parking-device-management'
          }, {
            value: '显示屏管理'
          }],
        },
        mainTitle: '修改显示屏',
        subheading: '',

        displayCode: '',
        displayName: '',
        displayType: '',
        displayTypeList: [
          {code: '四行四字', name: '四行四字'}
        ],
        applicationScenario: '',
        applicationScenarioList: [
          {code: '入场', name: '入场'},
          {code: '出场', name: '出场'}
        ],
        deviceCode: '',
        deviceName: '',
        deviceList: [],
        staticList: [],
        monthlyList: [],
        enterList: [],
        vehicleList: [],

        staticInfo: [
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'}
        ],

        monthlyInfo: [
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'}
        ],

        enterInfo: [
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'}
        ],

        vehicleInfo: [
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'},
          {code: '', name: '', isStatic: '1'}
        ],
        deviceShowItems : []
      }
    },
    created () {
      this.displayCode = this.$route.params.id
      this.getStaticSelect()
      this.getMonthlySelect()
      this.getEnterSelect()
      this.getVehicleSelect()
      this.getDeviceShowParkingDeviceList()
    },
    methods: {
      // 获取相机列表
      getDeviceShowParkingDeviceList () {
        this.$axios.get(api.getDeviceShowParkingDeviceList, {})
          .then(res => {
            let list = res.data.data
            this.deviceList = list
            setTimeout(() => {
              this.getParkingDeviceByCode()
            }, 100)
          })
          .catch(errorHandler('获取相机列表失败'))
      },

      // 获取显示屏详情
      getParkingDeviceByCode () {
        this.$axios.get(`${api.getDisplayByCode}/${this.displayCode}`, {})
          .then(res => {
            let data = res.data.data
            this.deviceList.unshift({
              code: data.deviceCode,
              name: data.deviceName
            })
            this.displayName = data.displayName
            this.displayType = data.displayType
            this.applicationScenario = data.applicationScenario
            this.deviceCode = data.deviceCode
            this.deviceName = data.deviceName
            this.deviceShowItems = data.deviceShowItems
            let staticContentArr = data.staticContent.split(',')
            staticContentArr.map((v, i) => {
              if (v.indexOf('G000000') === -1) {
                this.staticInfo[i].code = this.staticList[this.staticList.length - 1].code
                data.deviceShowItems.map(cat => {
                  if (cat.code === v) {
                    this.staticInfo[i].name = cat.name
                  }
                })
              } else {
                this.staticInfo[i].code = v
              }
            })
            let fixedContentArr = data.fixedContent.split(',')
            fixedContentArr.map((v, i) => {
              if (v.indexOf('G000000') === -1) {
                this.monthlyInfo[i].code = this.monthlyList[this.monthlyList.length - 1].code
                data.deviceShowItems.map(cat => {
                  if (cat.code === v) {
                    this.monthlyInfo[i].name = cat.name
                  }
                })
              } else {
                this.monthlyInfo[i].code = v
              }
            })
            let temInContentArr = data.temInContent.split(',')
            temInContentArr.map((v, i) => {
              if (v.indexOf('G000000') === -1) {
                this.enterInfo[i].code = this.enterList[this.enterList.length - 1].code
                console.log(data.deviceShowItems)
                console.log(v)
                data.deviceShowItems.map(cat => {

                  if (cat.code === v) {
                    this.enterInfo[i].name = cat.name
                  }
                })
              } else {
                this.enterInfo[i].code = v
              }
            })
            let temOutContentArr = data.temOutContent.split(',')
            temOutContentArr.map((v, i) => {
              if (v.indexOf('G000000') === -1) {
                this.vehicleInfo[i].code = this.vehicleList[this.vehicleList.length - 1].code
                data.deviceShowItems.map(cat => {
                  if (cat.code === v) {
                    this.vehicleInfo[i].name = cat.name
                  }
                })
              } else {
                this.vehicleInfo[i].code = v
              }
            })
          })
          .catch(errorHandler('获取设备数据失败'))
      },

      // 查询静态可选栏目
      getStaticSelect () {
        this.$axios.get(`${api.getSelect}/static_content`, {})
          .then(res => {
            let list = res.data.data
            list.push({
              code: this.getNonceStr(),
              isStatic: '1',
              name: '自定义'
            })
            this.staticInfo.map(v => {
              v.code = list[0].code
            })
            this.staticList = list
          })
          .catch(errorHandler('获取可选栏目失败'))
      },

      // 查询包月可选栏目
      getMonthlySelect () {
        this.$axios.get(`${api.getSelect}/monthly_car_display`, {})
          .then(res => {
            let list = res.data.data
            list.push({
              code: this.getNonceStr(),
              isStatic: '1',
              name: '自定义'
            })
            this.monthlyList = list
          })
          .catch(errorHandler('获取可选栏目失败'))
      },

      // 查询临停进可选栏目
      getEnterSelect () {
        this.$axios.get(`${api.getSelect}/enter_parking_display`, {})
          .then(res => {
            let list = res.data.data
            list.push({
              code: this.getNonceStr(),
              isStatic: '1',
              name: '自定义'
            })
            this.enterList = list
          })
          .catch(errorHandler('获取可选栏目失败'))
      },

      // 查询临停出可选栏目
      getVehicleSelect () {
        this.$axios.get(`${api.getSelect}/vehicle_appearance_display`, {})
          .then(res => {
            let list = res.data.data
            list.push({
              code: this.getNonceStr(),
              isStatic: '1',
              name: '自定义'
            })
            this.vehicleList = list
          })
          .catch(errorHandler('获取可选栏目失败'))
      },

      add () {
        if (!this.displayName) {
          nError('请输入显示屏名称')
          return false
        }
        if (!this.deviceCode) {
          nError('请选择关联相机')
          return false
        }
        let obj = {
          displayCode: this.displayCode,
          displayName: this.displayName,
          displayType: this.displayType,
          applicationScenario: this.applicationScenario,
          deviceCode: this.deviceCode,
          deviceName: this.deviceName,
          staticContent: '',
          fixedContent: '',
          temInContent: '',
          temOutContent: '',
          deviceShowItems: this.deviceShowItems
        }
        this.deviceList.map(v => {
          if (v.code === this.deviceCode) {
            obj.deviceName = v.name
          }
        })
        // 静态
        let staticContentArr = []
        this.staticInfo.map(v => {
          if (v.code.indexOf('G000000') === -1) {
            let deviceShowItem = v
            deviceShowItem.code = this.getNonceStr()
            staticContentArr.push(deviceShowItem.code)
            obj.deviceShowItems.push(deviceShowItem)
          } else {
            staticContentArr.push(v.code)
          }
        })
        obj.staticContent = staticContentArr.join(',')
        // 包月
        let fixedContentArr = []
        this.monthlyInfo.map(v => {
          if (v.code.indexOf('G000000') === -1) {
            let deviceShowItem = v
            deviceShowItem.code = this.getNonceStr()
            fixedContentArr.push(deviceShowItem.code)
            obj.deviceShowItems.push(deviceShowItem)
          } else {
            fixedContentArr.push(v.code)
          }
        })
        obj.fixedContent = fixedContentArr.join(',')
        if (this.applicationScenario === '入场') {
          // 临停入场
          let temInContentArr = []
          this.enterInfo.map(v => {
            if (v.code.indexOf('G000000') === -1) {
              let deviceShowItem = v
              deviceShowItem.code = this.getNonceStr()
              temInContentArr.push(deviceShowItem.code)
              obj.deviceShowItems.push(deviceShowItem)
            } else {
              temInContentArr.push(v.code)
            }
          })
          obj.temInContent = temInContentArr.join(',')
        } else {
          // 临停出场
          let temOutContentArr = []
          this.vehicleInfo.map(v => {
            if (v.code.indexOf('G000000') === -1) {
              let deviceShowItem = v
              deviceShowItem.code = this.getNonceStr()
              temOutContentArr.push(deviceShowItem.code)
              obj.deviceShowItems.push(deviceShowItem)
            } else {
              temOutContentArr.push(v.code)
            }
          })
          obj.temOutContent = temOutContentArr.join(',')
        }
        this.$axios.post(api.saveOrUpdateDisplay, obj)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('修改成功')
              this.strategyCenter()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'display-manage'
        })
      },

      // 获取随机数
      getNonceStr() {
        let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        let str = ''
        for (let i = 0; i < 9; i++) {
          let id = Math.ceil(Math.random() * 34)
          str += chars[id]
        }
        return str
      }
    },
    watch: {}
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 12px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .form-line>div {
    display: block;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/Display/DisplayModify.vue